import { useEffect, useRef } from 'react';

export const useOutsideClick = (handler, deps, outsideException, disableOutsideClick = false) => {
  const ref = useRef(null);

  useEffect(() => {
    const listener = (event) => {
      if (!disableOutsideClick && !ref.current?.contains(event.target)) {
        (
          (outsideException && !document.querySelector(outsideException)?.contains(event.target))
          || !outsideException
        ) && handler(event);
      }
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, deps ? [ref, ...deps] : [ref, handler]);

  return ref;
};
